/**
 * INTACT — interactions globales
 * Menu mobile, tiroir panier, rotation du bandeau d'annonce (crossfade).
 * Vanilla JS uniquement, pas de dépendance.
 */
(function () {
  /* Menu mobile */
  var menuToggle = document.querySelector("[data-menu-toggle]");
  var mobileNav = document.querySelector("[data-mobile-nav]");

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener("click", function () {
      var isOpen = mobileNav.classList.toggle("mobile-nav--open");
      menuToggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
      document.body.classList.toggle("no-scroll", isOpen);
    });
  }

  /* Tiroir panier */
  var cartTriggers = document.querySelectorAll("[data-cart-toggle]");
  var cartDrawer = document.querySelector("[data-cart-drawer]");

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove("cart-drawer--open");
    document.body.classList.remove("no-scroll");
  }

  cartTriggers.forEach(function (trigger) {
    trigger.addEventListener("click", function (event) {
      if (!cartDrawer) return;
      event.preventDefault();
      cartDrawer.classList.add("cart-drawer--open");
      document.body.classList.add("no-scroll");
    });
  });

  var cartClose = document.querySelector("[data-cart-close]");
  if (cartClose) cartClose.addEventListener("click", closeCart);

  if (cartDrawer) {
    cartDrawer.addEventListener("click", function (event) {
      if (event.target === cartDrawer) closeCart();
    });
  }

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeCart();
  });

  /* Bandeau d'annonce — rotation en crossfade */
  var announcementBar = document.querySelector("[data-announcement-bar]");
  if (announcementBar) {
    var messages = announcementBar.querySelectorAll("[data-announcement-message]");
    var interval = parseInt(announcementBar.getAttribute("data-interval"), 10) || 4500;

    if (messages.length > 1) {
      var current = 0;
      messages[current].classList.add("announcement__message--active");

      window.setInterval(function () {
        var next = (current + 1) % messages.length;
        messages[current].classList.remove("announcement__message--active");
        messages[next].classList.add("announcement__message--active");
        current = next;
      }, interval);
    }
  }

  /* Ancre douce vers le formulaire sur-mesure depuis n'importe quel CTA */
  document.querySelectorAll('[data-scroll-to]').forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      var targetId = trigger.getAttribute('data-scroll-to');
      var target = document.getElementById(targetId);
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* Barre d'achat collante (mobile) : apparaît quand le vrai bouton
     "Ajouter au panier" sort de l'écran, et relaie le clic vers lui. */
  var primaryBuyButton = document.querySelector('[data-primary-add-to-cart]');
  var stickyBar = document.querySelector('[data-sticky-buy-bar]');

  if (primaryBuyButton && stickyBar) {
    var stickyTrigger = stickyBar.querySelector('[data-sticky-buy-trigger]');
    if (stickyTrigger) {
      stickyTrigger.addEventListener('click', function () {
        primaryBuyButton.click();
      });
    }

    var buyButtonObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var isAboveViewport = entry.boundingClientRect.top < 0;
          stickyBar.classList.toggle(
            'sticky-buy-bar--visible',
            !entry.isIntersecting && isAboveViewport
          );
        });
      },
      { threshold: 0 }
    );
    buyButtonObserver.observe(primaryBuyButton);
  }
})();
